// @ts-nocheck
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/Reorder";
import constants from "@store/constants";
import getCanOnlyOrderSample from "@store/Framework/Common/Utilities/samples/getCanOnlyOrderSample";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const AfterPopulateApiParameter = createChainHandler("AfterPopulateApiParameter", chain, props => {
    const state = props.getState();
    const order = getOrderState(state, state.pages.orderDetails.orderNumber);

    props.apiParameter.cartLines?.forEach(cartLine => {
        const orderLine = order.value?.orderLines?.find(
            x => x.productId === cartLine.productId && x.unitOfMeasure === cartLine.unitOfMeasure,
        );

        if (orderLine && getCanOnlyOrderSample(state, orderLine)) {
            cartLine.unitOfMeasure = constants.sampleUOM;
        }
    });
});

addToChainAfter(chain, PopulateApiParameter, AfterPopulateApiParameter);
